import { esc } from '../core/state.js';

/** Mirrors trade.ts: malformed bindings remain bound; any equipped slot blocks an offer. */
export function gearTradeRestriction(e, equipped = {}) {
  if (e.guildBound != null) return { kind: 'bound', label: '거래 불가', detail: '계정 귀속 · 벗어도 다른 사람과 거래할 수 없다.' };
  if (Object.values(equipped).includes(e.id)) return { kind: 'worn', label: '벗으면 거래', detail: '착용 중 · 먼저 벗으면 거래에 등록할 수 있다.' };
  return null;
}

export function gearTradeLabel(e, equipped) {
  const rule = gearTradeRestriction(e, equipped);
  return rule ? `<span class="geartrade ${rule.kind}" title="${esc(rule.detail)}">${rule.label}</span>` : '';
}
